import React from 'react'
import { useQuery } from "@apollo/client"
import Spinner from "../Spinner/Spinner"
import { GET_ANNOUNCES_COUNT } from "../../../graphql/index"
import { serialize, declensionWords } from "../../../utils"
import { INITIAL_FILTER } from "../../../constant"
import css from './Announces.module.scss'

export default function Counter ({ variables = INITIAL_FILTER, limit = 10, query = GET_ANNOUNCES_COUNT}) {
	const { loading, data } = useQuery(query,{variables: serialize(variables)})

	return (
		<div className={css.counter}>
			{loading ? <Spinner align={'left'}/> : null}
			{!loading && data?.resultCounter
				? <span className={css.count}>
					{declensionWords(data.resultCounter,['Найден','Найдено','Найдено'])}
					&nbsp;
					<b>{data.resultCounter}</b>
					&nbsp;
					{declensionWords(data.resultCounter,['материал','материала','материалов'])}
				</span>
				: null}
		</div>
	)
}